import React from 'react'
import { SimpleHeader } from '../SimpleHeader/SimpleHeader'
import { MainContentTemplate } from '../MainContentTemplate/MainContentTemplate'
import { useStyles } from './CustomerInfoTemplate.styles'

export interface CustomerInfoTemplateProps {
  logoUrl?: string
  backgroundImgUrl?: string
  children: React.ReactNode
  bgColor?: string
}

export const CustomerInfoTemplate: React.FC<CustomerInfoTemplateProps> = ({
  logoUrl,
  backgroundImgUrl,
  children,
  bgColor,
}) => {
  const { classes } = useStyles()
  return (
    <div className={classes.root} data-testid="customer-info-template">
      <SimpleHeader logoUrl={logoUrl} />
      <MainContentTemplate
        backgroundImgUrl={backgroundImgUrl}
        children={children}
        bgColor={bgColor}
      />
    </div>
  )
}
